import React from 'react';
import { normalizeEmail } from 'utils';
import classNames from 'classnames';
import {
  DataRoomRfiRecipient,
  DataRoomRFIStatus,
} from 'router/subrouters/DataRoom/models/DataRoomRfi';
import { useTranslation } from 'react-i18next';
import { getFormattedDate } from 'dateUtils';
import { getIsRfiStatusClosed } from 'router/subrouters/DataRoom/utils';
import SendReminderButton from './components/SendReminderButton';
import ResolvePopup from 'components/ResolvePopup';

import './RecipientsList.styles.scss';

type RecipientsListProps = {
  className?: string;
  rfiId: string;
  status: DataRoomRFIStatus;
  allRecipientsWithReminders: DataRoomRfiRecipient[];
  updateAllRecipientsWithReminders: (
    allRecipientsWithReminders: DataRoomRfiRecipient[],
  ) => void;
};

const RecipientsList: React.FC<RecipientsListProps> = (props) => {
  const {
    className,
    rfiId,
    status,
    allRecipientsWithReminders,
    updateAllRecipientsWithReminders,
  } = props;

  const classes = classNames('recipients-list', className);

  const { t } = useTranslation();

  if (!allRecipientsWithReminders.length)
    return <p>{t('thereAreCurrentlyNoRecipientsAvailable')}</p>;

  return (
    <div className={classes}>
      {allRecipientsWithReminders.map(({ email, forwarded, reminders }) => (
        <div key={email} className="recipients-list__container">
          <div className="heading">
            <div>
              <span>{normalizeEmail(email)}</span>

              {forwarded && (
                <span className="forwarded">({t('forwarded')})</span>
              )}
            </div>

            {!getIsRfiStatusClosed(status) && (
              <SendReminderButton
                rfiId={rfiId}
                email={email}
                allRecipientsWithReminders={allRecipientsWithReminders}
                updateAllRecipientsWithReminders={
                  updateAllRecipientsWithReminders
                }
              />
            )}
          </div>

          {!!reminders.length && (
            <div className="reminded">
              <p>
                {t('lastRemindedOn', {
                  date: getFormattedDate(reminders[reminders.length - 1]),
                })}
              </p>

              {reminders.length > 1 && (
                <ResolvePopup
                  onHover
                  popupContent={
                    <ol className="resolve-popup-ol">
                      {reminders.map((date) => (
                        <li key={+new Date(date)}>{getFormattedDate(date)}</li>
                      ))}
                    </ol>
                  }
                >
                  <p>
                    {t('reminderHistory', {
                      count: reminders.length,
                    })}
                  </p>
                </ResolvePopup>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default RecipientsList;
